<template>
  <a-modal
    v-model="visible"
    title="Mark Activity Log"
    :width="950"
    :footer="null"
    @cancel="handleCancel"
  >
    <a-spin :spinning="loading">
      <a-table
        :columns="columns"
        :data-source="activities"
        :pagination="{ pageSize: 5 }"
        row-key="id"
        size="small"
      >
        <template slot="causer" slot-scope="causer">
          {{ causer ? `${causer.first_name} ${causer.last_name}` : 'System' }}
        </template>
        <template slot="date_format" slot-scope="text">
          {{ moment(text).format('DD-MM-YYYY hh:mm A') }}
        </template>
        <template slot="old_value" slot-scope="text, record">
          <div v-if="record.properties && record.properties.old">
            <a-tag v-if="record.properties.old.mark !== undefined" color="red">{{ record.properties.old.mark }}</a-tag>
            <a-tag v-else-if="record.properties.old.grade !== undefined" color="red">{{ record.properties.old.grade }}</a-tag>
          </div>
        </template>
        <template slot="new_value" slot-scope="text, record">
          <div v-if="record.properties && record.properties.attributes">
            <a-tag v-if="record.properties.attributes.mark !== undefined" color="green">{{ record.properties.attributes.mark }}</a-tag>
            <a-tag v-else-if="record.properties.attributes.grade !== undefined" color="green">{{ record.properties.attributes.grade }}</a-tag>
          </div>
        </template>
      </a-table>
    </a-spin>
  </a-modal>
</template>

<script>
import moment from 'moment'

export default {
  name: 'ActivityLogModal',
  data() {
    return {
      visible: false,
      loading: false,
      activities: [],
      columns: [
        {
          title: 'User',
          dataIndex: 'causer',
          scopedSlots: { customRender: 'causer' },
        },
        {
          title: 'Description',
          dataIndex: 'description',
        },
        {
          title: 'Old Mark',
          scopedSlots: { customRender: 'old_value' },
        },
        {
          title: 'New Mark',
          scopedSlots: { customRender: 'new_value' },
        },
        {
          title: 'Created At',
          dataIndex: 'created_at',
          scopedSlots: { customRender: 'date_format' },
        },
        {
          title: 'Updated At',
          dataIndex: 'updated_at',
          scopedSlots: { customRender: 'date_format' },
        },
      ],
    }
  },
  mounted() {
    this.$eventBus.$on('openMarkActivityLog', this.show)
  },
  beforeDestroy() {
    this.$eventBus.$off('openMarkActivityLog', this.show)
  },
  methods: {
    moment,
    show(markId) {
      if (!markId) return
      this.visible = true
      this.fetchActivities(markId)
    },
    fetchActivities(markId) {
      this.loading = true
      this.$http
        .get(`/api/studentexammark/${markId}/activities`)
        .then(({ data }) => {
          this.activities = data.data
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          this.$neoNotify.error(error)
        })
    },
    handleCancel() {
      this.visible = false
      this.activities = []
    },
    formatKey(key) {
      return key.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
    },
  },
}
</script>
